export default __webpack_public_path__ + "static/constat_it-40f1fa256d7884cafc0627295c281b95.mp4";